import React from "react";
import PropTypes from "prop-types";
import times from "lodash/times";
import MonthDay from "./MonthDay";

const {
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../../../../constants");

function MonthWeek(
  {
    startOfWeek,
    handleSelectDate,
    selectedDates,
    scheduledSessions,
    handleRemoveMultiple,
    dragging = false,
    expanded = false,
  },
  { locals: { query } }
) {

  return (
    <article className={expanded ? " expanded" : ""}>
      {times(7, (day) => {
        const date = startOfWeek.clone().add(day, "days");
        const dayString = date.clone().format(DATE_DAY_FORMAT);
        const isSelected = selectedDates.includes(dayString);

        return (
          <MonthDay
            key={dayString}
            date={date}
            handleSelectDate={handleSelectDate}
            isSelected={isSelected}
            selectedDates={selectedDates}
            scheduledSessions={scheduledSessions}
            handleRemoveMultiple={handleRemoveMultiple}
            dragging={dragging}
            expanded={expanded}
          />
        );
      })}
    </article>
  );
}

MonthWeek.contextTypes = { locals: PropTypes.object };

export default MonthWeek;
